import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import SubmenuControl from './SubmenuControl';

class Submenu extends React.Component {
    renderCloseControl() {
        const { close } = this.props;

        if (!close) {
            return null;
        }

        return (
            <SubmenuControl onClick={close} type="close">
                <Isvg src="/svg/arrow-down-mobile.svg" />
            </SubmenuControl>
        );
    }

    renderCancelControl() {
        const { cancel } = this.props;

        if (!cancel) {
            return null;
        }

        return (
            <SubmenuControl onClick={cancel} type="cancel">
                <Isvg src="/svg/cancel.svg" />
            </SubmenuControl>
        );
    }

    renderConfirmControl() {
        const { confirm } = this.props;

        if (!confirm) {
            return null;
        }

        return (
            <SubmenuControl onClick={confirm} type="confirm">
                <Isvg src="/svg/confirm.svg" />
            </SubmenuControl>
        );
    }

    render() {
        return (
            <div className="submenu">
                <div className="submenu__above-head">{this.props.aboveHead}</div>
                <div className="submenu__head">
                    <span className="submenu__label">{this.props.label}</span>
                    <span className="submenu__label">{this.props.icon}</span>
                    <div className="submenu__controls">
                        {this.renderCloseControl()}
                        {this.renderCancelControl()}
                        {this.renderConfirmControl()}
                    </div>
                </div>
                <div className="submenu__notification-container">{this.props.notification}</div>
                <div className="submenu__body">{this.props.children}</div>
            </div>
        );
    }
}

Submenu.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    children: PropTypes.node,
    close: PropTypes.func,
    confirm: PropTypes.func,
    cancel: PropTypes.func,
    aboveHead: PropTypes.node,
    notification: PropTypes.node,
};

Submenu.defaultProps = {
    label: '',
    children: null,
    close: undefined,
    confirm: undefined,
    cancel: undefined,
    aboveHead: null,
    notification: null,
};

export default Submenu;
